// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1lZIc","footerWrapper":"footer_footerWrapper__3ls1o"};